// Bootstrap and SbAdmin
require('bootstrap/dist/js/npm');
require('startbootstrap-sb-admin-2/bower_components/metisMenu/dist/metisMenu');
require('startbootstrap-sb-admin-2/dist/js/sb-admin-2.js');
require('../../cropper/cropping');


// Angular
require('./admin.module');
require('./discounts/services/edit.controller');
require('./discounts/services/index.controller');
require('./discounts/camp-discounts/edit.controller');
require('./discounts/camp-discounts/index.controller');
require('./mountains/regions/edit.controller');
require('./mountains/regions/index.controller');
require('./mountains/mountains/edit.controller');
require('./mountains/mountains/index.controller');
require('./mountains/mountains/view.controller');
require('./mountains/peak/edit.controller');
require('./mountains/routes/edit.controller');
require('./mountains/routes/index.controller');
require('./ascent/edit.controller');
require('./ascent/index.controller');
require('./user/edit.controller');
require('./user/token_users.controller');
require('./user/index.controller');
require('./club/index.controller');
require('./committee/edit.controller');
require('./camp/index.controller');
require('./page/index.controller');
require('./page/edit.controller');
require('./news/index.controller');
require('./document/edit.controller');
require('./document/index.controller');
require('./blog/rubric.controller');
require('./blog/post.controller');
require('./menu/menu.controller');
require('./news-archive/index.controller');
require('./news-archive/edit.controller');
